export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-img1-6645be9c54dc451e8bf9e3e8b1eead67.jpg";